import {
  ageGroupLabels,
  colorPaletteLabels,
  culturalContextLabels,
  genderLabels,
  genreLabels,
  intensityLevelLabels,
  moodLabels,
  performanceContextLabels,
  seasonalityLabels,
} from './assetEnumLabels';

const ENUM_LABELS_BY_KEY: Record<string, Record<string, string>> = {
  gender: genderLabels,
  genre: genreLabels,
  mood: moodLabels,
  energy: intensityLevelLabels,
  ageGroup: ageGroupLabels,
  targetAudience: ageGroupLabels,
  performanceContext: performanceContextLabels,
  culturalContext: culturalContextLabels,
  colorPalette: colorPaletteLabels,
  season: seasonalityLabels,
  seasonality: seasonalityLabels,
};

const formatSingleMetadataValue = (key: string, value: unknown): string | boolean => {
  if (typeof value === 'boolean') {
    return value;
  }

  const labelMap = ENUM_LABELS_BY_KEY[key];
  if (labelMap && typeof value === 'string') {
    return labelMap[value] ?? value;
  }

  if (typeof value === 'string') {
    return value;
  }

  return String(value);
};

export type FormattedMetadataValue = string | boolean | string[] | null;

export const formatMetadataDisplayValue = (
  key: string,
  value: unknown
): FormattedMetadataValue => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return null;
    }

    return value.map((item) => {
      const formatted = formatSingleMetadataValue(key, item);
      return typeof formatted === 'boolean' ? (formatted ? 'Yes' : 'No') : formatted;
    });
  }

  return formatSingleMetadataValue(key, value);
};
